import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const AuthAwareCTAButtons = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleStartJourney = () => {
    if (isAuthenticated) {
      navigate('/dashboard');
    } else {
      navigate('/signup');
    }
  };

  const handleAlreadyHaveAccount = () => {
    navigate('/signin');
  };

  return (
    <>
      <button
        onClick={handleStartJourney}
        className="btn-primary w-full sm:w-auto min-h-[48px]"
      >
        {isAuthenticated ? 'Go to Dashboard' : 'Start Your Journey'}
      </button>
      
      {!isAuthenticated && (
        <button
          onClick={handleAlreadyHaveAccount}
          className="btn-secondary w-full sm:w-auto min-h-[48px]"
        >
          Already Have Account?
        </button>
      )}
    </>
  );
};

export default AuthAwareCTAButtons;
